import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "axios";
import { ApiHost } from "../../utils/ApiConfig";
import ValidationInfo from "./ValidationInfo";
import { validateNIP, validateDigits } from "../../utils/Validators";
import InfoPopup from "./InfoPopup";
import config from "../../config";


import logger from "../../utils/logger";
const GusSearch = ({ visible, handleSearch, handleCancel }) => {
  const { accessToken } = useAuth();

  const [nip, setNip] = useState("");
  const [departments, setDepartments] = useState([]);
  const [selectionLabel, setSelectionLabel] = useState("");
  const [nipInvalid, setNipInvalid] = useState();
  const [warningTrigger, setWarningTrigger] = useState(0);
  const [loading, setLoading] = useState(false);

  const debug = config.runmode.debug;

  const validateNipField = (value) => {
    const invalid = validateNIP(value) ? "false" : "true";
    setNipInvalid(invalid);
  };

  const handleNipInput = (e) => {
    const tempNip = e.target.value.replace(/[^0-9]/g, "");
    if (tempNip === "" || validateDigits(tempNip, 10)) {
      setNip(tempNip);
    }
  };

  const handleNipKeyPress = (e) => {
    if (e.key === "Enter" && nipInvalid === "false") {
      e.preventDefault();
      gusSearch();
    }
  };

  const gusSearch = async () => {
    setLoading(true);
    try {
      debug && logger.log(`Pobieranie danych z GUS [${nip}]`);
      const response = await axios.post(
        `${ApiHost}/gus/search`,
        { nip },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      debug && logger.log(response.data);
      processResponse(response.data);
    } catch (error) {
      logger.warn("Błąd pobierania danych z GUS:", error);
      setWarningTrigger((prev) => prev + 1);
    } finally {
      setLoading(false);
    }
  };

  const processResponse = (data) => {
    if (Array.isArray(data) && data.length > 1) {
      setSelectionLabel("Wybierz firmę");
      const list = data.map((item) => formatItem(item));
      setDepartments(list);
      return;
    }
    if (Array.isArray(data) && data.length === 1) {
      const item = data[0];
      if (item.Departments && item.Departments.length > 0) {
        setSelectionLabel("Wybierz oddział");
        const list = [formatItem(item), ...item.Departments.map(formatItem)];
        setDepartments(list);
      } else {
        handleSearch(formatItem(item));
        handleCancel();
      }
      return;
    }
    const obj = data;
    if (!obj.Departments || obj.Departments.length === 0) {
      handleSearch(formatItem(obj));
      handleCancel();
      return;
    }
    if (obj.Departments.length === 1) {
      handleSearch(formatItem(obj.Departments[0]));
      handleCancel();
      return;
    }
    setSelectionLabel("Wybierz oddział");
    const list = [formatItem(obj), ...obj.Departments.map(formatItem)];
    setDepartments(list);
  };

  const formatItem = (item) => ({
    Name: item.Name,
    NIP: nip,
    Street: item.Street,
    Building: item.Building,
    Appartment: item.Number || "",
    PostCode: item.PostCode,
    City: item.City,
    Id: item.Regon || "00000000-0000-0000-0000-000000000000",
  });

  const handleSelect = (e) => {
    const val = e.target.value;
    if (!val) return;
    const item = JSON.parse(val);
    handleSearch(item);
    handleCancel();
  };

  useEffect(() => {
    validateNipField(nip);
  }, [nip]);

  useEffect(() => {
    if (visible) {
      setDepartments([]);
      setSelectionLabel("");
    }
  }, [visible]);

  if (!visible) return null;

  return (
    <div>
      <div className="card mt-1">
        <div className="w-100">
          <div className="d-flex align-items-center mb-1">
            <label className="form-label">NIP *</label>
            {nipInvalid === "true" && (
              <ValidationInfo
                title="Wpisz poprawny numer NIP (10 cyfr)."
                visible={true}
              />
            )}
          </div>
          <div className="d-flex flex-row">
            <input
              type="text"
              className="form-control my-0 w7"
              maxLength="14"
              value={nip}
              onChange={handleNipInput}
              onKeyDown={handleNipKeyPress}
              placeholder="Numer NIP, np. 5422838585"
              onBlur={(e) => validateNipField(e.target.value)}
              required
              invalid={nipInvalid}
            />
            {loading ? (
              <div className="btn btn-outline-primary ms-1 d-flex align-items-center w11">
                Pobieranie danych&nbsp;
                <div
                  className="ms-auto spinner-border"
                  style={{ height: "18px", width: "18px" }}
                />
              </div>
            ) : (
              <button
                className="btn btn-primary ms-1 my-0 w11"
                type="button"
                onClick={gusSearch}
                disabled={nipInvalid !== "false" || loading}
              >
                {loading ? "Ładowanie…" : "Pobierz dane z GUS"}
              </button>
            )}

            <button
              className="btn btn-outline-primary ms-1 my-0 w7"
              type="button"
              onClick={handleCancel}
            >
              Zamknij
            </button>
          </div>

          {departments.length >= 2 && (
            <div className="d-flex flex-row mt-1">
              <div className="w-100">
                <label className="form-label mb-0">{selectionLabel}</label>
                <select
                  className="form-control form-select my-0 rounded-3 w-100"
                  onChange={handleSelect}
                >
                  <option value="">Wybierz z listy</option>
                  {departments.map((dep, i) => (
                    <option key={i} value={JSON.stringify(dep)}>
                      {dep.Name} ({dep.City})
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </div>
        <InfoPopup
          title="Błąd pobierania danych z GUS. Sprawdź numer NIP."
          trigger={warningTrigger}
          warning={true}
        />
      </div>
    </div>
  );
};

export default GusSearch;


